export default "__VITE_ASSET__f6c4ae4c__"